export default __webpack_public_path__ + "static/media/logo.6037e914.png";